import { css as reactCss } from '@emotion/react';

export const primaryButtonStyle = reactCss({
  fontSize: '14px',
  lineHeight: '20px',
  textAlign: 'center',
  padding: '16px',
  height: '60px',
  width: '100%',
  borderColor: 'transparent',
  background: 'black',
  color: 'white',
});
